module.exports = __webpack_public_path__ + "static/media/BookmarkIcon.7600f7a0.svg";